exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RVCA1{padding:17px 0 0}._3Funz{background-color:#fff;border-bottom:1px solid #e0e0e0;border-radius:2px 2px 0 0}._1lurM,.HZaAw{margin-bottom:20px}.h-nxT{margin:0 auto}._39pxm{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._281L-{position:relative}._1v4mP{width:calc(100% - 300px);padding-right:20px}._1TUv6{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._1pjGJ{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}._2wekj{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._3eoZS{margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"page": "RVCA1 page",
	"navWrapper": "_3Funz",
	"Juan": "HZaAw",
	"gptPremium": "_1lurM",
	"container": "h-nxT container",
	"flexRow": "_39pxm flexRow",
	"flexCell": "_281L-",
	"mainCell": "_1v4mP",
	"sideBar": "_1TUv6",
	"flexGrow0": "_1pjGJ",
	"flexGrow1": "_2wekj",
	"advertContainerGl": "_3eoZS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/firms/Firms.css
// module id = 3059
// module chunks = 22